import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { CheckCircle, XCircle, Coffee, Mail, Phone, Globe, CreditCard, User, AlertCircle, Loader2, Search, Trash2, Edit2, ChevronLeft, ChevronRight, ChevronDown, ChevronUp } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const GetInfos = () => {
    const [pendingData, setPendingData] = useState([])
    const [cafesData, setCafesData] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [creatingId, setCreatingId] = useState(null)
    const [successMessage, setSuccessMessage] = useState(null)
    const [customTablesInput, setCustomTablesInput] = useState({})

    // Table states
    const [searchTerm, setSearchTerm] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage] = useState(10)
    const [editingDate, setEditingDate] = useState(null)
    const [deletingId, setDeletingId] = useState(null)
    const [expandedCafe, setExpandedCafe] = useState(null)
    const navigate = useNavigate()
    const [refresh,setRefresh]=useState(false)
    useEffect(() => {
        fetchPendingForms()
    }, [refresh])

    const fetchPendingForms = () => {
        Promise.all([
axios.get(`${process.env.REACT_APP_API_URL}/getForms`,{headers:{'token-jwt':localStorage.getItem('adminToken')}}),
axios.get(`${process.env.REACT_APP_API_URL}/getCoffee`,{headers:{'token-jwt':localStorage.getItem('adminToken')}}),
        ])
        
            .then(([r,t]) => {
                setPendingData(r.data.data)
                setLoading(false)
                setCafesData(t.data.data)
            })
            .catch(err => {
                console.error(err)
                setError('Erreur lors du chargement des inscriptions')
                setLoading(false)
                if(err?.response?.data?.redirectTo){
                    navigate('/login/admin')
                }
                
            })
    }

   

    const handleCreateCafe = (e, index) => {
        setCreatingId(index)
        setSuccessMessage(null)
        setError(null)  
        console.log(e)
        
        axios.post(`${process.env.REACT_APP_API_URL}/create`, e,{headers:{'token-jwt':localStorage.getItem('adminToken')}})
            .then(r => {
                setSuccessMessage(`Café "${e.nomCafe}" créé avec succès!`)
                setCreatingId(null)
                fetchPendingForms()
                setTimeout(() => setSuccessMessage(null), 5000)
            })
            .catch(err => {
                setError(err.response?.data?.message || 'Erreur lors de la création')
                setCreatingId(null)
                if(err?.response?.data?.redirectTo){
                    navigate('/login/admin')
                }
            })
    }

    const handleDeleteCafe = (cafeId) => {
        if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce café?')) return
        
        setDeletingId(cafeId)
        axios.delete(`${process.env.REACT_APP_API_URL}/deleteCafe/${cafeId}`,{headers:{'token-jwt':localStorage.getItem('adminToken')}})
            .then(() => {
                setSuccessMessage('Café supprimé avec succès')
                setDeletingId(null)
                setTimeout(() => setSuccessMessage(null), 3000)
            })
            .catch(err => {
                setError('Erreur lors de la suppression')
                setDeletingId(null)
                if(err?.response?.data?.redirectTo){
                    navigate('/login/admin')
                }
            })
    }
    const handleDelteForm=(id)=>{
        axios.delete(process.env.REACT_APP_API_URL+'/delete-form/'+id,{headers:{'token-jwt':localStorage.getItem('adminToken')}})
        .then(r=>setRefresh(!refresh))
        .catch(err=>console.log(err))
    }
    const handleUpdateapiKeyExpiresAt = (cafeId, newDate) => {
        axios.put(`${process.env.REACT_APP_API_URL}/updateCreatedAt/${cafeId}`, { createdAt: newDate },{headers:{'token-jwt':localStorage.getItem('adminToken')}})
            .then(() => {
                setSuccessMessage('Date mise à jour')
                setEditingDate(null)
                setTimeout(() => setSuccessMessage(null), 3000)
            })
            .catch(err => {
                setError('Erreur lors de la mise à jour de la date')
                if(err?.response?.data?.redirectTo){
                    navigate('/login/admin')
                }
            })
    }
    // Filter and pagination logic
    const filteredCafes = cafesData.filter(cafe => 
        cafe.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        cafe.email?.toLowerCase().includes(searchTerm.toLowerCase())
    )

    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentCafes = filteredCafes.slice(indexOfFirstItem, indexOfLastItem)
    const totalPages = Math.ceil(filteredCafes.length / itemsPerPage)

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-slate-900 to-blue-900 flex items-center justify-center">
                <div className="text-center">
                    <Loader2 className="w-12 h-12 text-blue-400 animate-spin mx-auto mb-4" />
                    <p className="text-white text-lg">Chargement...</p>
                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 to-blue-900 py-6 px-4">
            <div className="max-w-[1800px] mx-auto">
                {/* Header */}
                <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-xl p-6 mb-6 border border-white/20">
                    <h1 className="text-3xl font-bold text-white flex items-center gap-3">
                        <Coffee className="w-8 h-8 text-blue-400" />
                        Dashboard Admin
                    </h1>
                    <p className="text-gray-300 mt-2">
                        {pendingData.length} inscription{pendingData.length > 1 ? 's' : ''} en attente • {cafesData.length} café{cafesData.length > 1 ? 's' : ''} actif{cafesData.length > 1 ? 's' : ''}
                    </p>
                </div>

                {/* Success/Error Messages */}
                {successMessage && (
                    <div className="bg-green-500/20 border border-green-500 rounded-lg p-4 mb-6 flex items-start gap-3 backdrop-blur">
                        <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                        <p className="text-green-100 font-medium">{successMessage}</p>
                    </div>
                )}

                {error && (
                    <div className="bg-red-500/20 border border-red-500 rounded-lg p-4 mb-6 flex items-start gap-3 backdrop-blur">
                        <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
                        <p className="text-red-100 font-medium">{error}</p>
                    </div>
                )}

                {/* Two Column Layout */}
                <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
                    {/* Left Side: Pending Registrations */}
                    <div className="xl:col-span-1">
                        <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-xl p-6 border border-white/20 sticky top-6">
                            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-2">
                                <AlertCircle className="w-6 h-6 text-yellow-400" />
                                En Attente ({pendingData.length})
                            </h2>
                            
                          <div className="space-y-4 max-h-[calc(100vh-250px)] overflow-y-auto pr-2">
    {pendingData.length === 0 ? (
        <p className="text-gray-400 text-center py-8">Aucune inscription en attente</p>
    ) : (
        pendingData.map((e, i) => (
            <div key={i} className="bg-white/5 rounded-xl p-4 border border-white/10 hover:bg-white/10 transition">
                <h3 className="text-lg font-bold text-white mb-3 flex items-center gap-2">
                    <Coffee className="w-4 h-4 text-blue-400" />
                    {e.nomCafe}
                    <span className='text-red-600 cursor-pointer'
                    onClick={()=>handleDelteForm(e.id)}>X</span>
                </h3>
                
                <div className="space-y-2 text-sm">
                    <div className="flex items-center gap-2 text-gray-300">
                        <User className="w-4 h-4 text-blue-400" />
                        {e.nomPerson}

                    </div>
                    <div className="flex items-center gap-2 text-gray-300">
                        <Mail className="w-4 h-4 text-blue-400" />
                        {e.email}
                    </div>
                    <div className="flex items-center gap-2 text-gray-300">
                        <Mail className="w-4 h-4 text-blue-400" />
                        {e.password}
                    </div>
                    <div className="flex items-center gap-2 text-gray-300">
                        <Phone className="w-4 h-4 text-blue-400" />
                        {e.phone}
                    </div>
                    <div className="flex items-center gap-2 text-gray-300">
                        <CreditCard className="w-4 h-4 text-blue-400" />
                        Plan: <span className="font-semibold text-blue-300">{e.plan}</span>
                    </div>
                </div>

                {/* Add Custom Tables Input - Only show for customize plan */}
                {e.plan === 'custom' && (
                    <div className="mt-3 pt-3 border-t border-white/10">
                        <label className="block text-xs text-gray-400 mb-2">
                            Nombre de tables personnalisées
                        </label>
                        <input
                            type="number"
                            min="1"
                            placeholder="Ex: 30"
                            value={customTablesInput[i] || ''}
                            onChange={(e) => setCustomTablesInput({
                                ...customTablesInput,
                                [i]: e.target.value
                            })}
                            className="w-full px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 placeholder-gray-500"
                        />
                    </div>
                )}

                <button
                    onClick={() => handleCreateCafe({
                        cafeName: e.nomCafe,
                        email: e.email,
                        plan: e.plan,
                        phone: e.phone,
                        nomPerson: e.nomPerson,
                        ...(e.plan === 'custom' && customTablesInput[i] && {
                            customTables: parseInt(customTablesInput[i])
                        })
                    }, i)}
                    disabled={creatingId === i || (e.plan === 'custom' && !customTablesInput[i])}
                    className={`w-full mt-4 py-2 px-4 rounded-lg font-semibold transition-all flex items-center justify-center gap-2 ${
                        creatingId === i || (e.plan === 'custom' && !customTablesInput[i])
                            ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                            : e.plan === 'custom'
                            ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:from-purple-700 hover:to-pink-700'
                            : 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white hover:from-blue-700 hover:to-cyan-700'
                    }`}
                >
                    {creatingId === i ? (
                        <>
                            <Loader2 className="w-4 h-4 animate-spin" />
                            Création...
                        </>
                    ) : (
                        <>
                            <CheckCircle className="w-4 h-4" />
                            {e.plan === 'custom' && !customTablesInput[i] ? 'Entrez le nombre de tables' : 'Créer'}
                        </>
                    )}
                </button>
            </div>
        ))
    )}
</div>
                        </div>
                    </div>

                    {/* Right Side: Cafes Table */}
                    <div className="xl:col-span-2">
                        <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-xl border border-white/20 overflow-hidden">
                            {/* Table Header */}
                            <div className="p-6 border-b border-white/20">
                                <div className="flex items-center justify-between mb-4">
                                    <h2 className="text-2xl font-bold text-white flex items-center gap-2">
                                        <Coffee className="w-6 h-6 text-blue-400" />
                                        Cafés Actifs ({filteredCafes.length})
                                    </h2>
                                </div>
                                
                                {/* Search Bar */}
                                <div className="relative">
                                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                    <input
                                        type="text"
                                        placeholder="Rechercher par nom, email..."
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setSearchTerm(e.target.value)
                                            setCurrentPage(1)
                                        }}
                                        className="w-full pl-10 pr-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                            </div>

                            {/* Table */}
                            <div className="overflow-x-auto">
                                <table className="w-full">
                                    <thead className="bg-white/5 border-b border-white/20">
                                        <tr>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Café</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Plan</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Start Date</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Date Expiration</th>
                                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-300 uppercase tracking-wider">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-white/10">
                                        {currentCafes.length === 0 ? (
                                            <tr>
                                                <td colSpan="6" className="px-6 py-12 text-center text-gray-400">
                                                    Aucun café trouvé
                                                </td>
                                            </tr>
                                        ) : (
                                            currentCafes.map((cafe, index) => (
                                                <React.Fragment key={index}>
                                                    <tr className="hover:bg-white/5 transition">
                                                        <td className="px-6 py-4">
                                                            <div>
                                                                <div className="font-semibold text-white">{cafe.name || 'N/A'}</div>
                                                                <div className="text-sm text-gray-400">{cafe.email || 'N/A'}</div>
                                                            </div>
                                                        </td>
                                                       
                                                        <td className="px-6 py-4">
                                                            <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                                                                cafe.plan === 'VIP' ? 'bg-purple-500/20 text-purple-300' :
                                                                cafe.plan === 'Basic' ? 'bg-blue-500/20 text-blue-300' :
                                                                'bg-green-500/20 text-green-300'
                                                            }`}>
                                                                {cafe.plan || 'N/A'}
                                                            </span>
                                                        </td>
                                                        {/* <td className="px-6 py-4">
                                                            <button
                                                                onClick={() => setExpandedCafe(expandedCafe === cafe.id ? null : cafe.id)}
                                                                className="flex items-center gap-2 hover:text-blue-400 transition"
                                                            >
                                                                <div>
                                                                   
                                                                </div>
                                                                {expandedCafe === cafe.id ? 
                                                                    <ChevronUp className="w-4 h-4 text-blue-400" /> : 
                                                                    <ChevronDown className="w-4 h-4 text-blue-400" />
                                                                }
                                                            </button>
                                                        </td> */}
                                                       
                                                        <td className="px-6 py-4 text-white">
                                                        {cafe.subscriptionStartDate ? new Date(cafe.subscriptionStartDate).toLocaleDateString('fr-FR', {
                                                                        day: '2-digit',
                                                                        month: 'short',
                                                                        year: 'numeric'
                                                                    }) : 'N/A'}
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            {editingDate === cafe.id ? (
                                                                <input
                                                                    type="datetime-local"
                                                                    defaultValue={cafe.subscriptionEndDate ? new Date(cafe.subscriptionEndDate).toISOString().slice(0, 16) : ''}
                                                                    onBlur={(e) => {
                                                                        if (e.target.value) {
                                                                            handleUpdateapiKeyExpiresAt(cafe.id, e.target.value)
                                                                        } else {
                                                                            setEditingDate(null)
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            handleUpdateapiKeyExpiresAt(cafe.id, e.target.value)
                                                                        } else if (e.key === 'Escape') {
                                                                            setEditingDate(null)
                                                                        }
                                                                    }}
                                                                    className="bg-white/10 border border-white/20 rounded px-2 py-1 text-white text-xs focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                    autoFocus
                                                                />
                                                            ) : (
                                                                <button
                                                                    onClick={() => setEditingDate(cafe.id)}
                                                                    className="text-sm text-gray-300 hover:text-white transition flex items-center gap-1"
                                                                >
                                                                    {cafe.subscriptionEndDate ? new Date(cafe.subscriptionEndDate).toLocaleDateString('fr-FR', {
                                                                        day: '2-digit',
                                                                        month: 'short',
                                                                        year: 'numeric'
                                                                    }) : 'N/A'}
                                                                    <Edit2 className="w-3 h-3" />
                                                                </button>
                                                            )}
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <button
                                                                onClick={() => handleDeleteCafe(cafe.id)}
                                                                disabled={deletingId === cafe.id}
                                                                className="text-red-400 hover:text-red-300 transition disabled:opacity-50"
                                                            >
                                                                {deletingId === cafe.id ? (
                                                                    <Loader2 className="w-5 h-5 animate-spin" />
                                                                ) : (
                                                                    <Trash2 className="w-5 h-5" />
                                                                )}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    
                                                  
                                                </React.Fragment>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <div className="p-6 border-t border-white/20 flex items-center justify-between">
                                    <p className="text-sm text-gray-400">
                                        Affichage {indexOfFirstItem + 1} à {Math.min(indexOfLastItem, filteredCafes.length)} sur {filteredCafes.length}
                                    </p>
                                    <div className="flex gap-2">
                                        <button
                                            onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                            disabled={currentPage === 1}
                                            className="px-3 py-2 bg-white/5 border border-white/20 rounded-lg text-white hover:bg-white/10 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            <ChevronLeft className="w-5 h-5" />
                                        </button>
                                        <span className="px-4 py-2 bg-white/10 border border-white/20 rounded-lg text-white">
                                            {currentPage} / {totalPages}
                                        </span>
                                        <button
                                            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                            disabled={currentPage === totalPages}
                                            className="px-3 py-2 bg-white/5 border border-white/20 rounded-lg text-white hover:bg-white/10 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            <ChevronRight className="w-5 h-5" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GetInfos